module.exports = __webpack_public_path__ + "static/media/SourceSans3-VariableFont_wght.ede5b94a.ttf";